<template>
  <div>
    <div class="main-title selfService">
      自助小工具
    </div>
    <div class="main-cates-zlj">
      <div
        class="item-block"
        v-for="(item, index) in selfServiceList"
        :key="index"
        :zz-sortid="index"
        :zz-sortname="item.name"
        @click="handleJump(item)"
      >
        <img class="imgCon" :src="item.imgUrl" />
        <div class="text">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
const selfServiceList = [
  {
    name: '物流查询',
    type: 'logisticsSearch',
    jumpUrl: 'zljgo://native_api?type=20&needlogin=1',
    imgUrl: require('../../../assets/img/logistics_search.png')
  },
  {
    name: '售后查询',
    type: 'afterSaleSearch',
    jumpUrl: 'zljgo://native_api?type=1&needlogin=1&content=https://feentry.zhuanzhuan.com/AfterSale?clientid=List',
    imgUrl: require('../../../assets/img/aftersal_search.png')
  },
  // {
  //   name: '投诉中心',
  //   type: 'compliantCenter',
  //   // jumpUrl: 'zljgo://native_api?type=1&needlogin=1&content=https%3A%2F%2Ffrontstatic.zhaoliangji.com%2Fpages%2Fshop-complaint%2Findex.html%3Fhideshare%3D1%26showclose%3D1',
  //   jumpUrl: 'https://feentry.zhuanzhuan.com/zlj?clientid=cs_sc_ts',
  //   imgUrl: require('../../../assets/img/complaint_center_zlj.png')
  // },
  {
    name: '常见问题',
    type: 'commonQuestion',
    // jumpUrl: 'zljgo://native_api?type=1&needlogin=1&content=https%3A%2F%2Ffrontstatic.zhaoliangji.com%2Fpages%2Fshop-complaint%2Findex.html%3Fhideshare%3D1%26showclose%3D1',
    jumpUrl: 'zljgo://native_api?type=1&content=https%3A%2F%2Ffrontstatic.zhaoliangji.com%2Fpages%2Fshop-h5%2Fkf-common-problem.html',
    imgUrl: require('../../../assets/img/common_question.png')
  },
  {
    name: '更多服务',
    type: 'moreService',
    jumpUrl: '',
    imgUrl: require('../../../assets/img/more_service.png')
  }
]
export default {
  name: 'SelfService',
  data() {
    return {
      selfServiceList
    }
  },
  methods: {
    handleJump: function(item) {
      const jumpUrl = item.jumpUrl
      if (item.type === 'moreService') {
        this.$router.push({
          name: 'ZljServiceList'
        })
        return
      }
      native.skipToUrl({ targetUrl: jumpUrl })
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'SelfService.less';
  @import '../HelpCenter.less';
</style>
